import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthenticate } from "../../../store/query/userAuthenticationQuery";
import useGlobalContext from "../../../contexts-hooks/hooks/useGlobalContext";
const useUserAuthentication = () => {
  const navigate = useNavigate();
  const { mutate, isPending } = useAuthenticate();
  const { state, dispatch } = useGlobalContext(); 

  useEffect( () => {
    mutate(undefined, {
      onSuccess: (data) => {
        if (data.token) {
          localStorage.setItem("token", data.token);
        }
        dispatch({ type: "SET_USER", payload: data.user });
        dispatch({ type: "SET_IS_AUTHENTICATED", payload: true });
      },
      onError: (error) => {
        console.log("error", error);
        navigate("/");
      },
    });
  }, []);
  return {
    isPending,
    navigate,
    state,
    dispatch,
    mutate,
  };
};

export default useUserAuthentication;
